import copy from "copy-to-clipboard";

import { showSnackbar } from "@/contexts/SnackbarContext";

export function copyToClipboardWithFeedback(
  text: string,
  message: string,
): void {
  const success = copy(text);
  if (!success) return;
  showSnackbar({ content: message, type: "success" });
}
